import { render, staticRenderFns } from "./foodSupplement.vue?vue&type=template&id=6a13005f&scoped=true&"
import script from "./foodSupplement.vue?vue&type=script&lang=js&"
export * from "./foodSupplement.vue?vue&type=script&lang=js&"
import style0 from "./foodSupplement.vue?vue&type=style&index=0&id=6a13005f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a13005f",
  null
  
)

export default component.exports